import { Card, CardContent, Stack, Typography, Box } from '@mui/material';

import type { TestProps } from '../../models';
import { fCurrency } from '../../utils/formatNumber';
import NumberPicker, { type NumberPickerProps } from '../../components/number-picker';

type TestPickerProps = {
	onQtyChange: NumberPickerProps['onChange'];
	test: TestProps;
};

/*
  Test selection card
*/
export const TestSelector = ({ test, onQtyChange }: TestPickerProps) => {
	const showOriginalPrice = test.discountedPrice !== undefined && test.discountedPrice !== test.price;
	const unitPrice = test.discountedPrice ?? test.price;

	return (
		<Card
			variant="outlined"
			sx={{
				width: 280,
				height: 300,
				display: 'flex',
				flexDirection: 'column',
				borderRadius: 2,
			}}
		>
			<CardContent
				sx={{
					display: 'flex',
					flexDirection: 'column',
					height: '100%',
					p: 2,
				}}
			>
				<Stack spacing={1.5} sx={{ flexGrow: 1 }}>
					<Typography variant="h6" fontWeight={600}>
						{test.name}
					</Typography>

					<Box sx={{ flexGrow: 1 }}>
						<Typography variant="body2" color="text.secondary">
							{test.desc}
						</Typography>
					</Box>
				</Stack>

				<Stack spacing={2}>
					<Stack direction="row" alignItems="baseline" spacing={0.5}>
						{showOriginalPrice && (
							<Typography variant="body1" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
								{fCurrency(test.price)}
							</Typography>
						)}
						<Typography variant="h6" fontWeight={700}>
							{fCurrency(unitPrice)}
						</Typography>
						<Typography variant="body2" color="text.secondary">
							/ each
						</Typography>
					</Stack>

					<Box sx={{ display: 'flex', justifyContent: 'center' }}>
						<NumberPicker onChange={onQtyChange} name={test.name} value={test.quantity || 0} min={test.min} />
					</Box>
				</Stack>
			</CardContent>
		</Card>
	);
};
